export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=template&id=a51027a6&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modal.vue?vue&type=template&id=a51027a6&
// module id = 1610
// module chunks = 0